export const ONE_CONTEXT_PROFILE_CONNECTION = 'ProfileConnection';
export const ONE_CONTEXT_TENANT = 'iam';
